import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, CircularProgress, Alert } from '@mui/material';
import { getToken } from 'src/auth';
import { api } from 'src/api/config';
import { SettingsTab } from '../components/SettingsTab';

function SettingsPageComponent({ token }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [financialInstitutions, setFinancialInstitutions] = useState([]);

  useEffect(() => {
    if (token) {
      fetchFinancialInstitutions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  async function fetchFinancialInstitutions() {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${api.hostname}/api/v1/fis/`, {
        headers: {
          'Authorization': `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) throw new Error('Failed to fetch FIs');

      const data = await response.json();
      setFinancialInstitutions(data.results || data);
    } catch (err) {
      console.error('Failed to fetch financial institutions:', err);
      setError(err.message || 'Failed to load financial institutions');
    } finally {
      setLoading(false);
    }
  }

  if (loading && financialInstitutions.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3 }}>
        {error}
      </Alert>
    );
  }

  return (
    <SettingsTab
      financialInstitutions={financialInstitutions}
      onSaveSettings={() => {
        // Refresh FI list after saving
        fetchFinancialInstitutions();
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  token: getToken(state),
});

export const SettingsPage = connect(mapStateToProps)(SettingsPageComponent);
